<template>
  <div v-if="hasInformationsGeneralesData">
    <h3 class="xl:mt-15 xl:mb-15 w-full">Personnes</h3>
    <div class="grid grid-cols-2 gap-x-5 justify-between">
      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <doughnut
            id-chart="gender"
            title="Genre"
            :labels="gender.longLabels"
            :values="gender.datas"
            thickness="70"
            :colors="[color('pink'), color('indigo')]"
            position-legend="bottom"
            height="400"
            width="400"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            v-if="false && $can('cartography_collective_save')"
            class="py-2"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            class="py-2"
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
      </div>
      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="age"
            title="ages"
            orientation="horizontal"
            :labels="age.longLabels"
            :values="age.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="true"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            v-if="$can('cartography_collective_save')"
            class="py-2"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            class="py-2"
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
      </div>
    </div>

    <h3 class="xl:mt-15 xl:mb-10 w-full">Informations générales</h3>

    <div class="w-full flex flex-col space-y-2 items-center mb-10">
      <div>
        <doughnut
          class="w-50"
          id-chart="handicap"
          title="Handicap"
          :labels="handicap.longLabels"
          :values="handicap.datas"
          thickness="70"
          :colors="color('tenColors')"
          position-legend="right"
          height="375"
          width="700"
        />
      </div>
      <div class="flex justify-center">
        <action-button
          v-if="$can('cartography_collective_save')"
          class="py-2"
          border-color="border-transparent"
          text-color="text-white"
          bg-color="bg-gray-600"
          libelle="Enregistrer"
        />
        <action-button
          v-if="
            false && $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
          "
          class="py-2"
          border-color="border-transparent"
          text-color="text-gray-600"
          bg-color="bg-gray-300"
          libelle="Comparer"
        />
      </div>
    </div>

    <div class="grid grid-cols-2 gap-x-5 gap-y-10 justify-between">
      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="formations"
            title="Formations"
            orientation="vertical"
            :labels="formations.longLabels"
            :values="formations.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="mt-8 flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-5 mt-5">
          <div
            v-for="(lib, n) in formations.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('nineColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>
      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="situationanterieure"
            title="Situation antérieure"
            orientation="vertical"
            :labels="situationAnterieure.longLabels"
            :values="situationAnterieure.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-10 mt-5">
          <div
            v-for="(lib, n) in situationAnterieure.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('fourteenColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <doughnut
            id-chart="tempsTravail"
            title="Temps de travail"
            :labels="tempsTravail.longLabels"
            :values="tempsTravail.datas"
            thickness="70"
            :colors="[color('pink'), color('indigo')]"
            position-legend="bottom"
            height="400"
            width="400"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <doughnut
            id-chart="contrats"
            title="Contrats"
            :labels="contrats.shortLabels"
            :values="contrats.datas"
            thickness="70"
            :colors="color('tenColors')"
            position-legend="bottom"
            height="400"
            width="400"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <h5 class="text-indigo-600 font-bold mb-10">REMUNERATION</h5>
        <div class="border-dashed border-gray-600 rounded-2xl border-2 p-5">
          <div class="border-dashed border-gray-600 border-b-2 pb-5">
            <span
              class="inline-block border-2 rounded-full border-indigo-600 p-1.5 -mb-2 mr-2"
            >
              <icon class="text-indigo-600" name="collapse" />
            </span>
            {{ remuneration.moyenne }}€ rémunération moyenne brute
          </div>
          <div class="border-dashed border-gray-600 border-b-2 pb-5 pt-5">
            <span
              class="inline-block border-2 rounded-full border-pink-600 py-1 px-1.5 -mb-2 mr-2"
            >
              <icon class="text-pink-600" name="arrow-up" />
            </span>
            {{ remuneration.max }}€ rémunération brute la plus haute
          </div>
          <div class="pt-5">
            <span
              class="inline-block border-2 rounded-full border-pink-600 py-1 px-1.5 -mb-2 mr-2"
            >
              <icon class="text-pink-600" name="arrow-down" />
            </span>
            {{ remuneration.min }}€ rémunération brute la plus basse
          </div>
        </div>
      </div>
      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <doughnut
            id-chart="hebergement"
            title="Hébergement"
            :labels="hebergement.shortLabels"
            :values="hebergement.datas"
            thickness="70"
            :colors="color('eightColors')"
            position-legend="bottom"
            height="400"
            width="400"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="mobilite"
            title="Mobilité"
            orientation="vertical"
            :labels="mobilite.longLabels"
            :values="mobilite.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-10 mt-5">
          <div
            v-for="(lib, n) in mobilite.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('elevenColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="reconnaissance"
            title="Type de reconnaissance"
            orientation="vertical"
            :labels="reconnaissance.longLabels"
            :values="reconnaissance.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-10 mt-5">
          <div
            v-for="(lib, n) in reconnaissance.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('nineColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="statut"
            title="Statut"
            orientation="vertical"
            :labels="statut.longLabels"
            :values="statut.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-10 mt-5">
          <div
            v-for="(lib, n) in statut.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('eightColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>

      <div class="col-span-full xl:col-span-1 flex flex-col space-y-2">
        <div>
          <bar
            id-chart="qualification"
            title="Qualification"
            orientation="vertical"
            :labels="qualification.longLabels"
            :values="qualification.datas"
            :thickness="10"
            height="400"
            width="400"
            :stacked="false"
            :display-xaxis="false"
          />
        </div>
        <div class="w-full flex justify-center">
          <action-button
            class="py-2"
            v-if="$can('cartography_collective_save')"
            border-color="border-transparent"
            text-color="text-white"
            bg-color="bg-gray-600"
            libelle="Enregistrer"
          />
          <action-button
            class="py-2"
            v-if="
              false &&
              $can(constants.PERMISSION_CARTOGRAPHIE_COLLECTIVE_COMPARE)
            "
            border-color="border-transparent"
            text-color="text-gray-600"
            bg-color="bg-gray-300"
            libelle="Comparer"
          />
        </div>
        <div class="xl:ml-10 mt-5">
          <div
            v-for="(lib, n) in qualification.longLabels"
            :key="n"
            class="flex space-x-1 items-center"
          >
            <div
              class="h-2 w-2 rounded-full"
              :style="'backgroundColor: ' + color('nineColors')[n]"
            />
            <p class="text-2sm text-gray-600">
              {{ lib }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div v-else class="text-center mt-1/10 text-gray-600">
    Aucune donnée à afficher.
  </div>
</template>

<script>
import Icon from '../../../components/Icon';
import ActionButton from '../../../components/ActionButton';
import Doughnut from '../../../components/Charts/Doughnut';
import Bar from '../../../components/Charts/Bar';
import CollectiveCartographyDatas from '../../../mixins/CollectiveCartographyDatas.vue';

import Constants from './../../../constants';

export default {
  components: {
    Icon,
    ActionButton,
    Doughnut,
    Bar,
  },

  name: 'Informationsgenerales',

  data() {
    return {
      constants: Constants,
    };
  },

  methods: {
    ...CollectiveCartographyDatas.methods,
  },

  computed: {
    ...CollectiveCartographyDatas.computed,
  },
};
</script>
